module.exports = __webpack_public_path__ + "media/images/p_big2-52f865de6994b977c62b544f38ad69dc.jpg";